import React, { useState, useEffect } from 'react'
import axios from 'axios';
import jwt_decode from "jwt-decode";
import Navbar from "../../Navbar";
import Header from "../../Header";
import baseUrl from "../../BaseUrl";
import Loader from "../../Loader";
// import Pagination from "react-js-pagination";
import { useNavigate, Link } from 'react-router-dom';
import formatDateTimeToPST from '../../PSTDateConvert';
import Pagination from 'react-js-pagination';
import { saveAs } from 'file-saver';


const ImportSupportCarrierCnamHistory = () => {
    const [name, setName] = useState('');
    const [timeZone, setTimeZone] = useState('');
    const [token, setToken] = useState('');
    const [expire, setExpire] = useState('');
    const [role, setRole] = useState('');
    const [access, setAccess] = useState([]);
    const [cid, setCid] = useState('');
    const [popupOpen, setPopupOpen] = useState(false);
    const [importHistory, setImportHistory] = useState([])
    const [page, setPage] = useState(1);
    const [totalItem, setTotalItem] = useState(0);


    const navigate = useNavigate();

    useEffect(() => {
        getImportSupportCarrierCnamHistory();
    }, [page]);

    useEffect(() => {
        refreshToken();
        getUserAccess();
    }, []);

    useEffect(() => {
        if (access.length > 0 && token) {
            checkAccess(access, token);
        }
    }, [access, token]);

    const handlePageChange = (pageNumber) => {
        // console.log(`active page is ${pageNumber}`);
        setPage(pageNumber);
    }

    const getImportSupportCarrierCnamHistory = async () => {
        setPopupOpen(true);
        const response = await axiosJWT.get(`${baseUrl}/import-supported-carrier-cnam-history?page=${page}&limit=${20}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        console.log(response.data);
        setPopupOpen(false);
        setImportHistory(response.data.data)
        setTotalItem(response.data.totalItem)
    }

    // const exportErrors = async (abx) => {

    //     console.log(abx,'abx');

    //     const keysToInclude = Object.keys(abx).filter(key =>{return key !== 'importError' && key !== 'Success' && key !== 'telephoneNumberOrder'});
    //     const telephoneNumberOrder = abx['telephoneNumberOrder']

    //     const header = 'Tel Number,Status';
        
    //     // const rows = keysToInclude.map(key => `${key},${abx[key]}`);
    //     const rows = telephoneNumberOrder.map(phoneNumber => {
    //         const errorMessage = abx[phoneNumber.toString()];
    //         return `${phoneNumber},${errorMessage}`;
    //       });
    //     const csv = `${header}\n${rows.join('\n')}`;;

    //     // Create a Blob containing the CSV data
    //     const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      
    //     // Trigger the file download using file-saver
    //     saveAs(blob, 'ExportError.csv');
    // }

    const exportErrors = async (abx) => {
        console.log(abx, 'abx');
    
        // Filter out only the numeric keys (actual phone numbers)
        const keysToInclude = Object.keys(abx).filter(key => 
            key !== 'importError' && key !== 'telephoneNumberOrder' && !Array.isArray(abx[key]) // Exclude arrays
        );
    
        const header = 'Tel Number,Status';
        
        // Generate CSV rows only for filtered phone numbers
        const rows = keysToInclude.map(key => `${key},${abx[key]}`);
    
        const csv = `${header}\n${rows.join('\n')}`;
    
        // Create a Blob containing the CSV data
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    
        // Trigger the file download using file-saver
        saveAs(blob, 'CarrierCNAM.csv');
    };
    

    const getExportResult = async (id)=>{
        setPopupOpen(true)
        const response = await axiosJWT.get(`${baseUrl}/import-supported-carrier-cnam-export-result/${id}`,{
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        console.log(response.data.data)
        const exportResult = response.data.data
        
        await exportErrors(exportResult)

        setPopupOpen(false)
    }

    const refreshToken = async () => {
        try {
            const response = await axios.get(`${baseUrl}/token`);

            setToken(response.data.accessToken);
            const decoded = jwt_decode(response.data.accessToken);
            console.log(decoded.exp);
            setCid(decoded.cid);
            setName(decoded.name);
            setRole(decoded.role)
            setExpire(decoded.exp);
            setTimeZone(decoded.timezone)

        } catch (error) {

            if (error.response) {
                // setError("Unauthorized");
                navigate("/");
                window.location.reload();
            }
        }
    }

    const getUserAccess = async () => {
        try {
            const response = await axiosJWT.get(`${baseUrl}/user-access`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            console.log(response.data.results);
            setAccess(response.data.results);
            // setIsLoading(false);

        } catch (error) {
            console.log(error);

        }
    }

    const hasPermission = (permission) => {
        return access.some((item) => item.access === permission);
    };

    const checkAccess = async (access) => {
        if (role > 2) {
            navigate('/dashboard');
        }
    }

    const axiosJWT = axios.create();

    axiosJWT.interceptors.request.use(async (config) => {
        const currentDate = new Date();
        if (expire * 1000 < currentDate.getTime()) {
            const response = await axios.get(`${baseUrl}/token`);
            config.headers.Authorization = `Bearer ${response.data.accessToken}`;
            setToken(response.data.accessToken);
            const decoded = jwt_decode(response.data.accessToken);
            setCid(decoded.cid);
            setName(decoded.name);
            setRole(decoded.role)
            setExpire(decoded.exp);
        }
        return config;
    }, (error) => {
        return Promise.reject(error);
    });

    const handleFileDownload = async (filePath, type) => {
        try {
            setPopupOpen(true);
          // Make a request to your backend to get the pre-signed URL
          const path = `import_support_carrier_cnam/${type}/${filePath}`;
          const response = await axios.post(`${baseUrl}/get-dialed-number-file`, {path});
          const { presignedUrl } = response.data;
    
          // Create a temporary anchor element and trigger a download
          const link = document.createElement('a');
          link.href = presignedUrl;
          link.download = filePath.split('/').pop(); // Set the filename as the last part of the file path
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          setPopupOpen(false);
        // const newTab = window.open('', '_blank');
        //   newTab.document.write('<html><head><title>JSON Object</title></head><body><pre>' + JSON.stringify(response.data, null, 2) + '</pre></body></html>');
        //   newTab.document.close();
        } catch (error) {
          console.error('Error downloading the file', error);
          setPopupOpen(false);
        }
      };

    return (
        <div className="panelbox">
            <Navbar token={token} access={access} />
            <div className="right-panel">
                <Header name={name} />
                {popupOpen && (
                    <Loader />
                )}
                <div className="content-page">

                    <div className="row">
                        <div className="col-8">
                            <div className="left-title">
                                <h1>Check Supported Carrier CNAM History</h1>
                            </div>
                        </div>

                        <div className="col-4 top-right-buttons">
                            <div className="export-btn addnew-button"><Link to="/import-supported-carrier-cnam"><span>&larr;</span> Back</Link></div>
                        </div>

                    </div>


                    <div className="common-white-shadow-background setting-section">
                        <div className="row">
                            <div className=" setting-section haft-whitebox">
                                <div className="search-result-section">
                                    <h3></h3>
                                    {/* <div className="export-btn newrow"><a className="newrow" href="#">Export</a></div> */}
                                </div>
                                <table className="tablebox search-result-table">
                                    <thead>
                                        <tr>
                                            <th>Date ({timeZone})</th>
                                            <th>Company</th>
                                            <th>Name</th>
                                            <th>Input File</th>
                                            <th>Result</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {importHistory.map((importItem, index) => (
                                            <tr key={index}>
                                                <td>{formatDateTimeToPST(importItem.created_at, timeZone, role)}</td>
                                                <td>{importItem.cname}</td>
                                                <td>{importItem.full_name}</td>
                                                <td><a href="#" onClick={() => handleFileDownload(importItem.input_path, "input")}>{importItem.input_path}</a></td>
                                                <td>
                                                    {importItem.status == 2 ? <button onClick={() => { getExportResult(importItem.title)}}>  
                                                        <img src={`${process.env.PUBLIC_URL}/images/download.png`} alt="" />

                                                    </button>: "In-Progress"}
                                                </td>
                                            </tr>))}
                                    </tbody>
                                </table>

                                {totalItem > 20 && (<Pagination
                                    activePage={page}
                                    itemsCountPerPage={20}
                                    totalItemsCount={totalItem}
                                    pageRangeDisplayed={5}
                                    onChange={handlePageChange.bind(this)}
                                />)}

                            </div>
                        </div>
                    </div>

                </div>


            </div>
        </div>
    )
}

export default ImportSupportCarrierCnamHistory